'use client';

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchUserSettings, patchUserSettings, fetchCountries } from '../api/user-settings';
import type { UpdateUserSettingsData } from '../schemas/user-settings.schema';

export const userSettingsKeys = {
  all: ['user-settings'] as const,
  detail: () => [...userSettingsKeys.all, 'detail'] as const,
};

export const countriesKeys = {
  all: ['countries'] as const,
  list: () => [...countriesKeys.all, 'list'] as const,
};

export function useUserSettings() {
  return useQuery({
    queryKey: userSettingsKeys.detail(),
    queryFn: fetchUserSettings,
  });
}

export function useUpdateUserSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateUserSettingsData) => patchUserSettings(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: userSettingsKeys.all });
    },
  });
}

export function useCountries() {
  return useQuery({
    queryKey: countriesKeys.list(),
    queryFn: fetchCountries,
    staleTime: Infinity, // Countries list rarely changes
  });
}
